import {
  type ApplySchemaAttributes,
  ExtensionTag,
  MarkExtension,
  type MarkExtensionSpec,
  type MarkSpecOverride,
} from 'remirror';

export class StreamTokenExtension extends MarkExtension {
  get name() {
    return 'token' as const;
  }

  createTags() {
    return [ExtensionTag.FormattingMark, ExtensionTag.FontStyle];
  }

  createMarkSpec(
    extra: ApplySchemaAttributes,
    override: MarkSpecOverride
  ): MarkExtensionSpec {
    return {
      ...override,
      attrs: extra.defaults(),
      parseDOM: [
        {
          tag: 'token',
          getAttrs: extra.parse,
        },
        ...(override.parseDOM ?? []),
      ],
      toDOM: () => {
        return [
          'span',
          {
            class: 'streaming-token',
          },
          0,
        ];
      },
    };
  }
}
